import { EventCodeModel } from './eventcode-model';
import { EventModel } from './event-model';
import { SubEventModel } from './subevent-model';
import { SubEventCodeModel } from './subeventcode-model';
import { QuestionnaireResponseModel } from './questionnaireresponse-model';

export class GuestModel {

	constructor(
    private id : string,
		private firstName : string,
		private lastName : string,
		private email : string,
		private groupName : string,
		private eventCode : EventCodeModel,
		private nickName : string,
		private phone : string,
		private isCompanion : boolean,
		//TODO: categories (age group, relation to organizers etc)
		private detailsBySubEvent : Map<string,QuestionnaireResponseModel>,
		private topicVisits : Map<string,Date>,
		private guestbookVisit: Date) {
	}

  public getId() {
    return this.id;
  }

  public getFirstName() : string {
    return this.firstName;
  }

  public getLastName() : string {
    return this.lastName;
  }

  public hasValidFirstName() : boolean {
    return this.firstName != "" && this.firstName != "+1" && this.firstName != "?";
  }

  public hasValidLastName() : boolean {
    return this.lastName != "" && this.lastName != "+1" && this.lastName != "?";
  }

  public getFullName() : string {
    let firstAndLastName = "";
    if(!this.hasValidLastName() && this.hasValidFirstName()) {
      firstAndLastName = this.firstName;
    } else {
      if(this.hasValidLastName() && !this.hasValidFirstName()) {
        firstAndLastName = this.lastName;
      } else {
        firstAndLastName = this.firstName + " " + this.lastName;
      }
    }
    let fullName = firstAndLastName;
    if(this.nickName != "" && fullName == "") {
      fullName = this.nickName;
    }
    return fullName;
  }

  public getNickName() : string {
    return this.nickName;
  }

  public getEmail() : string {
    return this.email;
  }

  public getPhone() : string {
    return this.phone;
  }

  public getGroupName() : string {
    return this.groupName;
  }

  public getEventCode() : EventCodeModel {
    return this.eventCode;
  }

  public isAPlusOne() : boolean {
    return this.isCompanion;
  }

  public isInGroup(groupName: string) : boolean {
    return this.groupName === groupName;
  }

  public isIdentifiedBy(firstName: string, lastName: string) : boolean {
    return (this.firstName.toUpperCase() === firstName.toUpperCase() && this.lastName.toUpperCase() === lastName.toUpperCase());
  }

  public isInvitedTo(subEvent: SubEventModel) : boolean {//FIXME: move to SubEventModel class
     return this.detailsBySubEvent.get(subEvent.code.value) !== undefined;
  }

  private getSubEventDetails(subEvent: SubEventModel) : QuestionnaireResponseModel {
    let details = this.detailsBySubEvent.get(subEvent.code.value);
    if(details === undefined) {
      return new QuestionnaireResponseModel(undefined, new Map<string,any>());
    }
    return details;
  }

  public hasRepliedTo(event : EventModel) : boolean {
    return event.getSubEvents(this)
                  .every(subEvent => this.isComingTo(subEvent) !== undefined) === true;
  }

  public isComingTo(subEvent: SubEventModel) : boolean {
    return this.getSubEventDetails(subEvent).isComing();
  }

  public getResponseFor(subEvent: SubEventModel, question: string) : string {
    let response = this.getSubEventDetails(subEvent).getResponse(question);
    if(response === undefined) {
      return "";
    }
    return response;
  }

  public hasVisitedTopic(topicKey: string) : boolean {
    return this.getLastVisitDateForTopic(topicKey) !== null &&  this.getLastVisitDateForTopic(topicKey) !== undefined;
  }

  public getLastVisitDateForTopic(topicKey: string) : Date {
    return this.topicVisits.get(topicKey);
  }

  public setLastVisitDateForTopic(topicKey: string, visitDate: Date) : void {
    this.topicVisits.set(topicKey, visitDate);
  }

  public getLastVisitDateForGuestbook() : Date {
    return this.guestbookVisit;
  }

  public setLastVisitDateForGuestbook(visitDate: Date) : void {
    this.guestbookVisit = visitDate;
  }

  public getVisitedTopics() : Array<string> {
    return Array.from(this.topicVisits.keys());
  }

}



// WEBPACK FOOTER //
// ./src/app/models/guest-model.ts